export function decodeJWT(token) {
  const base64Url = atob(token.split('.')[1]);
  return JSON.parse(base64Url);
}

export function validateJWT(token) {
  const parsed = decodeJWT(token);
  const unixCurrentTime = Math.floor(Number(new Date()) / 1000);
  return parsed?.exp - unixCurrentTime > 0;
}
